module.exports = __webpack_public_path__ + "img/telegram-white.svg";